import { AnimatePresence, motion } from "framer-motion";
import { NAV_LINKS, WA_DEFAULT } from "./data";
import { WhatsAppIcon } from "./WhatsAppIcon";

export const MobileMenu = ({ open, onNavigate }) => (
  <AnimatePresence>
    {open && (
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.25 }}
        className="fixed inset-0 z-40 bg-ink/98 backdrop-blur-xl lg:hidden"
        data-testid="nav-mobile-menu"
      >
        <div className="flex h-full flex-col justify-center gap-2 px-8 pt-16">
          {NAV_LINKS.map((l, i) => (
            <motion.a
              key={l.hash}
              href={l.hash}
              onClick={(e) => onNavigate(e, l.hash)}
              initial={{ opacity: 0, x: -24 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ delay: 0.06 * i, duration: 0.4 }}
              className="border-b border-line py-4 font-display text-4xl font-extrabold uppercase tracking-tight text-white transition-colors hover:text-edge"
              data-testid={`nav-mobile-${l.testid}`}
            >
              {l.label}
            </motion.a>
          ))}
          <motion.a
            href={WA_DEFAULT}
            target="_blank"
            rel="noopener noreferrer"
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.4 }}
            className="clip-corner-sm mt-8 flex items-center justify-center gap-2 bg-edge px-6 py-4 font-display text-lg font-bold uppercase tracking-wider text-white"
            data-testid="nav-mobile-whatsapp-cta"
          >
            <WhatsAppIcon className="h-5 w-5" />
            WhatsApp Us
          </motion.a>
        </div>
      </motion.div>
    )}
  </AnimatePresence>
);
